import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import { Button } from 'src/features/tyre-management/components/ui/button';

const chip = (key, label, value) => (value ? { key, label: `${label}: ${value}` } : null);

const activeLabel = (value) => {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return '';
};

const optInLabel = (value) => {
  if (value === true) return 'Enabled';
  if (value === false) return 'Disabled';
  return '';
};

const AppliedFilters = ({
  query, siteName, groupName, globalEnabled, onRemove, onClear,
}) => {
  const chips = [
    chip('search', 'Search', query.search),
    chip('site', 'Site', siteName),
    chip('group', 'Group', groupName),
    chip('active', 'Active', activeLabel(query.active)),
    globalEnabled && chip('tyre_management_enabled', 'Tyre tracking', optInLabel(query.tyre_management_enabled)),
  ].filter(Boolean);

  if (!chips.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((item) => (
        <span key={item.key} className="vl-chip">
          {item.label}
          <button type="button" aria-label={`Remove ${item.label}`} onClick={() => onRemove(item.key)}>
            <X className="h-3.5 w-3.5" />
          </button>
        </span>
      ))}
      <Button type="button" variant="ghost" size="sm" onClick={onClear}>Clear all</Button>
    </div>
  );
};

AppliedFilters.propTypes = {
  query: PropTypes.object.isRequired,
  siteName: PropTypes.string,
  groupName: PropTypes.string,
  globalEnabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default AppliedFilters;
